import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
class SalesOpportunitiesTypes extends Component {

  standardRow = (type) => {
    return (
      <Row className="adminRow pointer text-left" onClick={() => this.props.onEdit(type.ID)}>
        <Col md={4}>{type.Opportunity}</Col>
        <Col md={8}>{type.Description}</Col>
      </Row>
    )
  }

  editRow = (type) => {
    return (
      <Row className="editRow adminRow">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="mr-2">
              <Input
                placeholder="Type"
                name="opportunity"
                value={this.props.editType.opportunity + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                placeholder="Description"
                name="description"
                value={this.props.editType.description + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Type">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(type.ID)} edit="Delete Type">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (<Row className="py-4 text-left align-items-bottom">
      <Col md={8}>
        <Form inline>
          <FormGroup className="mr-2">
            Add New Type
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              placeholder="Type"
              name="opportunity"
              value={this.props.newType.opportunity + ''}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              placeholder="Description"
              name="description"
              value={this.props.newType.description + ''}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
        </Form>
      </Col>
      <Col md={4} className="text-right">
        <Button
          disabled={this.props.newType.opportunity === '' || this.props.newType.description === ''}
          color="primary"
          onClick={this.props.handleAdd}>
          Add Type
        </Button>
      </Col>
    </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.types.map(type => (
          <Fragment key={type.ID}>{this.props.editType.id === type.ID ? this.editRow(type) : this.standardRow(type)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );
  }
}

export default SalesOpportunitiesTypes;